var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:[_vm.computedType, _vm.computedSize, _vm.computedOutline, _vm.computedActive, _vm.computedBlock],attrs:{"type":"button"}},[_vm._v(" "+_vm._s(_vm.btnText)+" "),_vm._t("eg"),_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }